// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ordis-topbar {
  background-color: #0F172A;
  color: white;
  padding: 1rem 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ordis-title {
  color: white;
  margin: 0;
  font-weight: 600;
}

.app-title {
  color: white;
  margin: 0;
  font-weight: 600;
  font-size: 1.5rem;
  margin-left: 0.75rem;
}

.app-logo {
  display: block;
  width: 40px;
  height: 40px;
  object-fit: contain;
  border-radius: 6px;
}

.header-button {
  background-color: #10B981 !important;
}

.header-button:hover {
  background-color: #059669 !important;
}

.user-alias-text {
  color: white !important;
  margin-right: 1rem;
  font-weight: 500;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .ordis-topbar {
    padding: 0.75rem 1rem;
  }
  
  .app-title {
    font-size: 1.25rem;
    margin-left: 0.5rem;
  }
}

@media (max-width: 480px) {
  .ordis-topbar {
    padding: 0.65rem 0.75rem;
  }
  
  .app-title {
    font-size: 1.1rem;
    margin-left: 0.4rem;
  }
  
  .header-button {
    transform: scale(0.9);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TopBar/TopBar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".ordis-topbar {\n  background-color: #0F172A;\n  color: white;\n  padding: 1rem 2rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.ordis-title {\n  color: white;\n  margin: 0;\n  font-weight: 600;\n}\n\n.app-title {\n  color: white;\n  margin: 0;\n  font-weight: 600;\n  font-size: 1.5rem;\n  margin-left: 0.75rem;\n}\n\n.app-logo {\n  display: block;\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n  border-radius: 6px;\n}\n\n.header-button {\n  background-color: #10B981 !important;\n}\n\n.header-button:hover {\n  background-color: #059669 !important;\n}\n\n.user-alias-text {\n  color: white !important;\n  margin-right: 1rem;\n  font-weight: 500;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n  .ordis-topbar {\n    padding: 0.75rem 1rem;\n  }\n  \n  .app-title {\n    font-size: 1.25rem;\n    margin-left: 0.5rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .ordis-topbar {\n    padding: 0.65rem 0.75rem;\n  }\n  \n  .app-title {\n    font-size: 1.1rem;\n    margin-left: 0.4rem;\n  }\n  \n  .header-button {\n    transform: scale(0.9);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
